import * as React from 'react';

function IconStatusErrorLarge(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M20 10L16 14L12 10L10 12L14 16L10 20L12 22L16 18L20 22L22 20L18 16L22 12L20 10Z"
        fill="currentColor"
      />
      <path
        d="M16 4C13.6266 4 11.3065 4.70379 9.33316 6.02236C7.35977 7.34094 5.82169 9.21509 4.91344 11.4078C4.00519 13.6005 3.76755 16.0133 4.23057 18.3411C4.6936 20.6689 5.83649 22.8071 7.51472 24.4853C9.19295 26.1635 11.3311 27.3064 13.6589 27.7694C15.9867 28.2324 18.3995 27.9948 20.5922 27.0866C22.7849 26.1783 24.6591 24.6402 25.9776 22.6668C27.2962 20.6935 28 18.3734 28 16C28 12.8174 26.7357 9.76515 24.4853 7.51472C22.2348 5.26428 19.1826 4 16 4ZM16 26C14.0222 26 12.0888 25.4135 10.4443 24.3147C8.7998 23.2159 7.51808 21.6541 6.7612 19.8268C6.00433 17.9996 5.80629 15.9889 6.19215 14.0491C6.578 12.1093 7.53041 10.3275 8.92893 8.92893C10.3275 7.53041 12.1093 6.578 14.0491 6.19215C15.9889 5.8063 17.9996 6.00433 19.8268 6.7612C21.6541 7.51808 23.2159 8.79981 24.3147 10.4443C25.4135 12.0888 26 14.0222 26 16C26 18.6522 24.9464 21.1957 23.0711 23.0711C21.1957 24.9464 18.6522 26 16 26Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default IconStatusErrorLarge;
